import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { api, formatPrice } from "../lib/api";

export default function OrderSuccess() {
  const { number } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${number}`).then((r) => setOrder(r.data)).catch(() => setOrder(false));
  }, [number]);

  if (order === false) {
    return (
      <div data-testid="order-not-found" className="container-cc py-32 text-center">
        <p className="eyebrow mb-3">Comandă negăsită</p>
        <p className="font-serif text-4xl font-light">Nu am găsit comanda {number}</p>
        <Link to="/catalog" className="btn-outline mt-8">Înapoi la catalog</Link>
      </div>
    );
  }

  return (
    <div data-testid="order-success-page" className="container-cc py-20 lg:py-32 max-w-3xl">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <span className="h-14 w-14 bg-[#0A0A0A] text-white flex items-center justify-center mb-8"><Check size={24} /></span>
        <p className="eyebrow mb-3">Comandă demo plasată</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">Mulțumim{order?.customer ? `, ${order.customer.first_name}` : ""}.</h1>
        <p className="mt-6 text-[#5A5A5A] leading-relaxed">
          Numărul comenzii tale demo este <span data-testid="order-number" className="font-semibold text-[#0A0A0A]">{number}</span>. Într-un magazin live, aici ai primi confirmarea pe email și detaliile de livrare. În acest demo, nu se procesează nicio plată și nu se expediază niciun produs.
        </p>
        {order && (
          <div className="surface p-8 mt-10" data-testid="order-summary">
            <ul className="divide-y divide-black/5">
              {order.items.map((i, idx) => (
                <li key={idx} className="py-3 flex justify-between text-sm"><span>{i.qty} × {i.name}{i.variant ? ` · ${i.variant}` : ""}</span><span className="font-medium">{formatPrice(i.price * i.qty)}</span></li>
              ))}
            </ul>
            <div className="flex justify-between pt-4 mt-2 border-t border-black/10 font-semibold"><span>Total</span><span data-testid="order-total">{formatPrice(order.total)}</span></div>
          </div>
        )}
        {order === false && null}
        <div className="mt-10 flex gap-3">
          <Link to="/catalog" className="btn-primary">Înapoi la catalog</Link>
          <Link to="/cont" className="btn-outline">Contul meu</Link>
        </div>
      </motion.div>
    </div>
  );
}
